var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceMinute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 23.628H24M14.7445 5.70797H17.2555M11.1825 2.66797H20.8175C22.5752 2.66797 24 3.96933 24 5.57464V26.428C24 28.0333 22.5752 29.3346 20.8175 29.3346H11.1825C9.42485 29.3346 8 28.0333 8 26.428V5.57464C8 3.96933 9.42485 2.66797 11.1825 2.66797Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 27.2423C16.5563 27.2423 17.0073 26.8304 17.0073 26.3223C17.0073 25.8142 16.5563 25.4023 16 25.4023C15.4437 25.4023 14.9927 25.8142 14.9927 26.3223C14.9927 26.8304 15.4437 27.2423 16 27.2423Z",
    fill: "#76BC21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceMinute);
export default __webpack_public_path__ + "static/media/serviceMinute.b63f4c3054d9c5c47d5a6c6ea776ffbf.svg";
export { ForwardRef as ReactComponent };